module.exports = __webpack_public_path__ + "static/media/slide2.b312ba56.webp";